import { ComponentProps } from 'react';

import CleanButton from '../../../CleanButton/CleanButton';
import InlineIcon from '../../../InlineIcon/InlineIcon';
import CalendarHeading from '../CalendarHeading/CalendarHeading';

import icon from './graphics/down.svg?raw';

import styles from './ClickableCalendarHeading.module.css';

type ClickableCalendarHeadingProps = {
    onClick: () => void;
} & Omit<ComponentProps<typeof CalendarHeading>, 'children'>;

const ClickableCalendarHeading = ({
    onClick,
    ...headingProps
}: ClickableCalendarHeadingProps) => {
    return (
        <CleanButton onClick={onClick} fullWidth className={styles.Root}>
            <CalendarHeading {...headingProps}>
                {() => (
                    <InlineIcon
                        src={icon}
                        size="small"
                        className={styles.Icon}
                    />
                )}
            </CalendarHeading>
        </CleanButton>
    );
};

export default ClickableCalendarHeading;
